const Payment = {
  path: '/payment/:id',
  name: 'payment',
  component: () => import('../../views/Payment/payment.vue'),
};

module.exports = {
  Payment,
};
